import { render, staticRenderFns } from "./ProjectCardReprintStamp.vue?vue&type=template&id=08cfda68"
import script from "./ProjectCardReprintStamp.vue?vue&type=script&lang=js"
export * from "./ProjectCardReprintStamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports